import { render, staticRenderFns } from "./InputListWrapper.form.vue?vue&type=template&id=229f44cf&scoped=true&"
import script from "./InputListWrapper.form.vue?vue&type=script&lang=js&"
export * from "./InputListWrapper.form.vue?vue&type=script&lang=js&"
import style0 from "./InputListWrapper.form.vue?vue&type=style&index=0&id=229f44cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229f44cf",
  null
  
)

export default component.exports